import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Input } from '../../common/components/formControls';
import { FormControl, Dropdown, MenuItem } from 'react-bootstrap';
import { loadUnpagedCenters } from './actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Checkbox } from 'react-icheck';
import 'icheck/skins/minimal/grey.css';
import { withTranslation, Trans } from 'react-i18next';

const DefaultSelectionMode = {
	NONE: 'none',
	FIRST: 'first'		// select first center on initial load
};

const RenderMode = {
	CONTROL: 'control',
	FIELD: 'field',			// render as redux-form field
	BUTTON: 'button'
};

class DropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	componentDidMount() {
		//this.props.loadUnpagedCenters();
	}

	componentWillReceiveProps(nextProps) {
		const { onChange, value, defaultSelectedId } = nextProps;

		// trigger onChange if dropdown value is set to First Center on initial load
		if (value == null && defaultSelectedId && onChange) {
			onChange(defaultSelectedId);
		}
	}

	handleSelectChange(selectedId) {
		const { onChange } = this.props;
		if (onChange) {
			onChange(selectedId);
		}
	}

	renderEmptyOption(emptyLabel) {
		return <option key='0' value=''>{emptyLabel}</option>;
	}

	renderOptions(data) {
		return data.map(center => {
			const isOnline = center.isOnline && center.territory && center.territory.isOnline;
			return <option key={center.id} value={center.id} className={isOnline ? '' : 'center-offline'}>{center.name}</option>;
		});
	}

	render() {
		const { render = RenderMode.CONTROL, defaultSelection = DefaultSelectionMode.NONE,
			data, name, value, defaultValue, onChange, hideEmptyOption, emptyLabel,
			defaultSelectedId, loadUnpagedCenters, filter, t, ...rest } = this.props;

		const selectedId = value || defaultSelectedId;

		switch (render) {
			case RenderMode.FIELD:
				return <Field name={name || 'centerId'} component={Input} componentClass='select'
					defaultValue={selectedId} onChange={e => this.handleSelectChange(e.target.value)} {...rest}>
					{hideEmptyOption || this.renderEmptyOption(emptyLabel)}
					{this.renderOptions(data)}
				</Field>;
			case RenderMode.BUTTON:
				// Ensure value is always an array for multi-select mode
				const selectedIds = Array.isArray(value) ? value : [];
				const toggleSelection = (id) => {
					let newSelected;
					if (selectedIds.includes(id)) {
						newSelected = selectedIds.filter(sid => sid !== id);
					} else {
						newSelected = [...selectedIds, id];
					}
					onChange && onChange(newSelected);
				};
				let multipleSelectedCentersDisplayName = null;
				const firstSelectedCenter = selectedIds.length > 0 ? data.find(c => c.id == selectedIds[0]).name : '';
				if (selectedIds.length > 1) {
					const count = selectedIds.length - 1;
					multipleSelectedCentersDisplayName = <Trans i18nKey='Centers_Multiple'>
						{{ firstSelectedCenter }}<span style={{ fontSize: 'smaller' }}> and {{ count }} other</span>
					</Trans>;
				}
				const selectedCentersDisplayName = selectedIds.length === 0 || selectedIds.length === data.length ? emptyLabel :
					selectedIds.length === 1 ? firstSelectedCenter : multipleSelectedCentersDisplayName;

				return (
					<Dropdown>
						<Dropdown.Toggle noCaret {...rest}>
							<span>{selectedCentersDisplayName} <FontAwesomeIcon icon={faChevronDown} /></span>
						</Dropdown.Toggle>
						<Dropdown.Menu className="dashboard-dropdown-menu" style={{ padding: '0.5rem' }}>
							{data.map(center => {
								const isOnline = center.isOnline && center.territory && center.territory.isOnline;
								const checked = selectedIds.includes(center.id);
								return (
									<MenuItem
										key={center.id}
										className="d-flex align-items-center">
										<label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', width: '100%' }}
											onClick={(e) => e.stopPropagation()} // prevent closing when label is clicked
										>
											<Checkbox checkboxClass='icheckbox_minimal-grey bg'
												label={<span className={isOnline ? '' : 'center-offline'}>{center.name}</span>}
												checked={checked}
												onClick={(e) => e.stopPropagation()}
												onChange={() => toggleSelection(center.id)}
											/>

										</label>
									</MenuItem>
								);
							})}
						</Dropdown.Menu>
					</Dropdown>
				);
			case RenderMode.CONTROL:
			default:
				// replace value with defaultSelectedId only if value is null or undefined
				// value = 0 is the value of the empty option, don't want to override it
				return <FormControl componentClass='select' placeholder='select' value={selectedId} onChange={e => this.handleSelectChange(e.target.value)} {...rest}>
					{hideEmptyOption || this.renderEmptyOption(emptyLabel)}
					{this.renderOptions(data)}
				</FormControl>;
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	const centers = state.entities.centers;

	let filteredCenters = Object.values(centers);
	//.filter(x => x.isOnline && x.territory && x.territory.isOnline);			// Online centers only

	const customFilter = ownProps.filter;
	if (customFilter && (typeof customFilter === 'function')) {
		filteredCenters = filteredCenters.filter(customFilter);
	}

	const orderedCenters = filteredCenters.sort((a, b) => {
		const a_isOnline = a.isOnline && a.territory && a.territory.isOnline ? 1 : 0;
		const b_isOnline = b.isOnline && b.territory && b.territory.isOnline ? 1 : 0;
		if (a_isOnline !== b_isOnline) {
			return a_isOnline < b_isOnline ? 1 : -1;
		}
		else
			return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
	});

	const firstCenter = orderedCenters[0];
	const defaultSelectedId = ownProps.defaultSelection === DefaultSelectionMode.FIRST && firstCenter && firstCenter.id.toString();

	return {
		data: orderedCenters,
		defaultSelectedId
	};
};

DropdownList.propTypes = {
	render: PropTypes.oneOf([RenderMode.CONTROL, RenderMode.FIELD, RenderMode.BUTTON]),
	defaultSelection: PropTypes.oneOf([DefaultSelectionMode.NONE, DefaultSelectionMode.FIRST]),
	name: PropTypes.string,
	onChange: PropTypes.func,
	filter: PropTypes.func,
	hideEmptyOption: PropTypes.bool,
	emptyLabel: PropTypes.string
};

export default connect(mapStateToProps, {
	loadUnpagedCenters
})(withTranslation()(DropdownList));